import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

export default class FootballPaperTalk extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    MoreNews: PropTypes.element.isRequired,
    MostReadFootball: PropTypes.element.isRequired
  };

  render() {
    const {
      location,
      MoreNews,
      MostReadFootball
    } = this.props;

    return (
      <div className="footballLeagues">
        <StandardPage sport="football" title="Paper talk" >
          <div className="main-layout-left-column">
            {MoreNews}
          </div>
          <div className="main-layout-block main-layout-hide-desktop">
            {MostReadFootball}
          </div>

          <RightColumn location={location}
                       sport="football"
                       content={["mostReadFootball", "topMpu"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballPaperTalk.js